import React, { useRef } from "react";

const MagneticButton = ({ children, onClick, className = "", as = "button", href, testId, ...rest }) => {
  const ref = useRef(null);

  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const x = e.clientX - (r.left + r.width / 2);
    const y = e.clientY - (r.top + r.height / 2);
    el.style.transform = `translate(${x * 0.25}px, ${y * 0.35}px)`;
  };
  const onLeave = () => {
    if (ref.current) ref.current.style.transform = "translate(0,0)";
  };

  const Tag = as === "a" ? "a" : "button";
  const tagProps = as === "a" ? { href } : {};

  return (
    <span
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      className="inline-block"
      data-magnetic="true"
    >
      <Tag
        ref={ref}
        onClick={onClick}
        data-testid={testId}
        {...tagProps}
        {...rest}
        className={`magnet-btn inline-flex items-center gap-3 px-7 py-4 rounded-full hairline-strong text-sm uppercase tracking-[0.25em] text-[#0a0a0b] transition-colors duration-300 will-change-transform ${className}`}
        style={{ transition: "transform 0.4s cubic-bezier(0.22, 1, 0.36, 1), color 0.3s, border-color 0.3s" }}
      >
        {children}
      </Tag>
    </span>
  );
};

export default MagneticButton;
